define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/conversation-sources/conversationSourcesLayout.tmpl");

    var ConversationSourcesLayout = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        ConversationSourcesLayout = Marionette.Layout.extend({
            className: "conversation-sources-layout",
            template: template,
            regions: {
                conversationSourcesGallery: ".conversation-sources-gallery-container"
            }
        });

    }

    LE.module("LEManager", moduleDefinition);


    return ConversationSourcesLayout;
});
